import _extends from 'babel-runtime/helpers/extends';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

import _ from 'lodash';
import configCard from './config-card.vue';
import { fetchCreationTagList } from '@/api/demand/creation';
import Vue from 'vue';

export default {
  components: {
    configCard: configCard
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    updateFeatureTag: {
      type: Function,
      default: function _default() {}
    },
    updateSceneNum: {
      type: Function,
      default: function _default() {}
    },
    handleCopyTag: {
      type: Function,
      default: function _default() {}
    },
    customButton: {
      type: Object
    },
    autoCompleteTag: {
      type: String,
      default: ''
    },
    autoScene: {
      type: String,
      default: ''
    },
    materialTagNames: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      formValue: {},
      featureValue: {
        creative_id: ''
      },
      completeByTag: '',
      currentCreative: '',
      options: []
    };
  },

  watch: {
    formValue: {
      handler: function handler() {
        var list = {};
        for (var key in this.formValue) {
          if (key === 'scene_num') {
            this.updateSceneNum(this.formValue['scene_num']);
          } else if (key && (typeof this.formValue[key] === 'number' || typeof this.formValue[key] === 'string')) {
            list[key.split('tag')[1]] = Number(this.formValue[key]);
          } else if (key) {
            list[key.split('tag')[1]] = '';
            for (var i in this.formValue[key]) {
              if (list[key.split('tag')[1]]) list[key.split('tag')[1]] += ',';
              list[key.split('tag')[1]] = list[key.split('tag')[1]] + this.formValue[key][i][this.formValue[key][i].length - 1];
            }
          }
        }
        var listLength = 0;
        for (var _key in list) {
          if (!list[_key]) {
            delete list[_key];
          } else {
            listLength += 1;
          }
        }
        this.updateFeatureTag(listLength > 0 ? _JSON$stringify(list) : '');
      },

      deep: true
    },
    autoCompleteTag: {
      handler: function handler(val) {
        this.fillTagForm(val);
      },

      immediate: true
    },
    autoScene: {
      handler: function handler(val) {
        var _this = this;

        this.$set(this.formValue, 'scene_num', val);
        this.$nextTick(function () {
          _this.updateSceneNum(_this.formValue['scene_num']);
        });
        //
      },

      immediate: true
    },
    completeByTag: {
      handler: function handler(newVal, oldVal) {
        if (!newVal && !oldVal) return;
        this.fillTagForm(newVal);
      },

      immediate: true
    },
    creative_id: function creative_id(val) {
      // // creative_id为空，清空当前表单内容
      // if (!val) {
      //   // 清空已选中的内容
      //   for (const key in this.formValue) {
      //     if (key !== 'scene_num') {
      //       Vue.delete(this.formValue, key)
      //     }
      //   }
      // }
    }
  },
  computed: {
    formItemList: function formItemList() {
      var _this2 = this;

      var list = [];
      // 非交互素材,非只读状态
      if (this.customButton && !this.readOnly) {
        list.push({
          label: '\u955C\u5934\u6570\u91CF\uFF1A',
          prop: 'scene_num',
          type: 'input',
          params: {
            style: 'width:100%;'
          },
          rules: [{ required: true, message: '请配置镜头数量' }, { pattern: /^\+?[1-9][0-9]*$/, message: '镜头数量为正整数' }]
        });
      }
      // 非只读状态表单
      if (!this.readOnly) {
        this.schemeValue.featureTagData.map(function (item, index) {
          var guideText = '\u672A\u8BBE\u7F6E\u5B50\u6807\u7B7E\uFF0C\u8BF7\u524D\u5F80\u521B\u610F\u6807\u7B7E\u7BA1\u7406\u8BBE\u7F6E';
          var hasSubTags = item.sub_tags && item.sub_tags.length > 0;
          if (item.input_type === 'select') {
            list.push({
              label: item.name + '\uFF1A',
              type: 'business',
              subtype: 'cascader-multi',
              prop: 'tag' + item.id,
              params: {
                style: 'width: 100%;',
                options: item.sub_tags,
                disabled: _this2.readOnly,
                handleChange: function handleChange() {
                  if (item.is_required === 1 && typeof _this2.formValue['tag' + item.id] !== 'undefined') {
                    _this2.$refs['form'].validateField('tag' + item.id);
                  }
                }
              },
              rules: [{
                required: item.is_required === 1 || false,
                message: hasSubTags ? '\u8BF7\u914D\u7F6E' + item.name : guideText,
                trigger: 'change'
              }]
            });
          } else if (item.input_type === 'number') {
            list.push({
              label: item.name + '\uFF1A',
              prop: 'tag' + item.id,
              params: {
                type: 'number',
                clearable: false,
                readonly: _this2.readOnly
              },
              rules: [{
                required: item.is_required === 1 || false,
                message: '\u8BF7\u914D\u7F6E' + item.name,
                trigger: 'change'
              }]
            });
          }
        });
      } else {
        //
      }

      return list;
    },
    featureItemList: function featureItemList() {
      var _this3 = this;

      var list = [{
        visible: !this.readOnly,
        label: '继承已有创意素材标签：',
        type: 'select',
        prop: 'creative_id',
        rules: [
          // {
          //   message: '请选择创意素材',
          //   trigger: 'change'
          // }
        ],
        params: {
          style: 'width:100%',
          filterable: true,
          disabled: false,
          clearable: true,
          remote: true,
          options: this.options,
          'remote-method': this.remoteData,
          placeholder: '请选择创意素材',
          handleChange: function handleChange(val) {
            _this3.getCreativeInfo(val);
          }
        }
      }];
      return list;
    },
    innerMaterialTag: function innerMaterialTag() {
      return this.materialTagNames ? JSON.parse(this.materialTagNames) : '';
    }
  },
  methods: {
    handleTagExtend: function handleTagExtend() {
      var _this4 = this;

      if (this.currentCreative.material_tag_ids) {
        this.completeByTag = this.currentCreative.material_tag_ids;
        if (this.currentCreative.scene_num) {
          this.$set(this.formValue, 'scene_num', this.currentCreative.scene_num);
          this.$nextTick(function () {
            _this4.updateSceneNum(String(_this4.formValue['scene_num']));
          });
        }
        this.$message({
          type: 'success',
          message: '继承成功。'
        });
      } else {
        this.$message('当前创意无特征标签');
      }
    },

    // 根据字符串填写标签表单项
    fillTagForm: function fillTagForm(val) {
      console.log(val);
      if (val) {
        var strVal = '';
        try {
          var tempObj = JSON.parse(val);
          for (var key in tempObj) {
            if (key && (typeof tempObj[key] === 'number' || typeof tempObj[key] === 'string')) {
              strVal = strVal + tempObj[key] + ',';
            } else {
              strVal = strVal + tempObj[key].join();
            }
          }
        } catch (err) {
          console.log(err);
        }
        var valTag = this.autoPickTagById(strVal, this.schemeValue.featureTagData);
        // 清空已选中的内容
        for (var _key2 in this.formValue) {
          if (_key2 !== 'scene_num') {
            Vue.delete(this.formValue, _key2);
          }
        }
        for (var _key3 in valTag) {
          this.$set(this.formValue, 'tag' + _key3, valTag[_key3]);
        }
      } else {
        // 清空已选中的内容
        for (var _key4 in this.formValue) {
          Vue.delete(this.formValue, _key4);
        }
      }
    },
    remoteData: function remoteData(query) {
      var _this5 = this;

      // 只读状态不请求数据接口
      if (this.readOnly) return;
      fetchCreationTagList({
        page: 1,
        page_size: 1000,
        search_field: 'keyword',
        keyword: query
      }).then(function (res) {
        _this5.options = (_.get(res, 'data.data.list') || []).map(function (item) {
          return _extends({}, item, {
            value: item.id,
            label: item.name
          });
        });
      }).catch(function () {
        _this5.options = [];
      });
    },
    getCreativeInfo: function getCreativeInfo(id) {
      var item = this.options.find(function (e) {
        return e.value === id;
      });
      this.currentCreative = item;
    },
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    autoPickTagById: function autoPickTagById(ids, tagTree) {
      var targetValue = {};
      var _ids = ids.split(',');
      // 根据id 获取节点
      var pickLeafById = function pickLeafById(targetId, obj) {
        var temp = '';
        obj.map(function (item) {
          if (temp) return;
          if (Number(item.id) === Number(targetId)) {
            temp = item;
          } else if (item.sub_tags) {
            temp = pickLeafById(targetId, item.sub_tags);
          }
        });
        return temp;
      };

      var pickParentByPid = function pickParentByPid(pid, obj, arr) {
        var item = pickLeafById(pid, _.clone(tagTree));
        arr.push(item);
        if (item.pid > 0) {
          pickParentByPid(item.pid, obj, arr);
        }
      };

      var leafList = [];
      _ids.map(function (id) {
        var temp = pickLeafById(id, _.clone(tagTree));
        if (temp) leafList.push(temp);
      });

      var leafRoot = [];
      leafList.map(function (item, index) {
        leafRoot[index] = [];
        pickParentByPid(item.pid, _.clone(tagTree), leafRoot[index]);
      });

      leafRoot.map(function (item, index) {
        // 遍历树结构最后一个节点，根节点
        var rootItem = item[item.length - 1];
        if (!targetValue[rootItem.id]) {
          targetValue[rootItem.id] = [];
        }
        var tempList = [];
        if (item.length > 1) {
          for (var i = item.length - 2; i >= 0; i--) {
            tempList.push(Number(item[i].id));
          }
        }
        tempList.push(Number(leafList[index].id));
        targetValue[rootItem.id].push(tempList);
      });

      return targetValue;
    }
  },
  mounted: function mounted() {
    if (!this.options.length) {
      this.remoteData('');
    }
  }
};